module.exports = {"pageTitleText":"支援"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/support.json
// module id = Rsta
// module chunks = 3